import { Card, CardContent, Box, Typography, keyframes } from '@mui/material';
import type { ReactNode } from 'react';

const pulse = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.7; }
`;

interface SummaryCardProps {
  title: string;
  value: number;
  icon: ReactNode;
  color: string;
  pulseAnimation?: boolean;
}

export function SummaryCard({ title, value, icon, color, pulseAnimation = false }: SummaryCardProps) {
  const displayValue = typeof value === 'number' ? value.toLocaleString() : '0';

  return (
    <Card
      sx={{
        height: '100%',
        position: 'relative',
        overflow: 'visible',
        transition: 'transform 0.2s, box-shadow 0.2s',
        '&:hover': {
          transform: 'translateY(-2px)',
          boxShadow: 3,
        },
      }}
    >
      <CardContent>
        <Box
          sx={{
            position: 'absolute',
            top: -10,
            right: 20,
            backgroundColor: color,
            borderRadius: 2,
            p: 1.5,
            color: 'white',
            boxShadow: 2,
            animation: pulseAnimation ? `${pulse} 2s infinite` : 'none',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {icon}
        </Box>

        <Typography variant="subtitle2" color="text.secondary" gutterBottom>
          {title}
        </Typography>

        <Typography variant="h4" component="div" sx={{ mt: 2, fontWeight: 600 }}>
          {displayValue}
        </Typography>
      </CardContent>
    </Card>
  );
}
